import { constants as config } from '@config';

import imagesFactory from '../../../factory/images';
import backgroundRemovalManager from '../../../utils/background-removal-manager';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  flipVertical: function (element) {
    if ($('#' + element.id + '-loader').length) {
      this.canvas.call('advice.show', 'image-flip-disabled');
      return;
    }

    this.canvas.selectOnly([element]);
    INKIVE.DesignFacade.set({ flipped: { vertical: true } });
  },

  flipHorizontal: function (element) {
    if ($('#' + element.id + '-loader').length) {
      this.canvas.call('advice.show', 'image-flip-disabled');
      return;
    }

    this.canvas.selectOnly([element]);
    INKIVE.DesignFacade.set({ flipped: { horizontal: true } });
  },

  removeBackground: async function () {
    const source = INKIVE.DesignFacade.get('background').source;

    if (!source || source === '<data>') {
      this.canvas.call('advice.show', 'save-first');
      return;
    }

    if (source) {
      const id = document.querySelector('.background > image').id;
      document.querySelector(`#svgcontent #${config.background.image}`).setAttribute('data-background-removed', 'true');
      this.trigger('remove_background.start', id);
      const { original, largeweb } = imagesFactory.getAllImageVersions(source);
      const imageUrl = largeweb || original;

      try {
        const url = await backgroundRemovalManager.removeBackground(imageUrl);

        INKIVE.DesignFacade.set('background', {
          source: { url, preload: true },
          keep_box_size: true,
          background_removed: true
        });

        this.trigger('remove_background.success', id);
      } catch (err) {
        this.trigger('remove_background.error', id);
      }
    }
  }
}, Backbone.Events);
